// frontend/src/api/api.js
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  (window.location.hostname === 'localhost' ? 'http://localhost:5006' : '');

axios.defaults.timeout = 600000;

// Migration: move token from sessionStorage to localStorage (one-time)
if (typeof window !== 'undefined') {
  const oldToken = sessionStorage.getItem('jwtToken');
  if (oldToken && !localStorage.getItem('jwtToken')) {
    localStorage.setItem('jwtToken', oldToken);
    sessionStorage.removeItem('jwtToken');
    console.log('[Auth] Migrated token from sessionStorage to localStorage');
  }
}

axios.interceptors.request.use(
  (config) => {
    if (typeof window !== 'undefined') {
      window.__activeRequestsCount = (window.__activeRequestsCount || 0) + 1;
      window.__lastApiActivity = Date.now();
    }
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Capture server-sent refreshed tokens and store them
axios.interceptors.response.use(
  (response) => {
    if (typeof window !== 'undefined') {
      window.__activeRequestsCount = Math.max((window.__activeRequestsCount || 1) - 1, 0);
      window.__lastApiActivity = Date.now();
    }
    const newToken = response?.headers?.['x-new-jwt'];
    if (newToken) {
      localStorage.setItem('jwtToken', newToken);
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('tokenRefreshed'));
      }
    }
    return response;
  },
  (error) => {
    if (typeof window !== 'undefined') {
      window.__activeRequestsCount = Math.max((window.__activeRequestsCount || 1) - 1, 0);
      window.__lastApiActivity = Date.now();
    }
    return Promise.reject(error);
  }
);

const handleResponse = (response) => {
  return response.data;
};

const handleError = (error) => {
  console.error('API Error:', error);
  if (error.response) {
    console.error('Response data:', error.response.data);
    console.error('Response status:', error.response.status);
  } else if (error.request) {
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.error('Request timed out:', error.message);
    } else {
      console.error('No response received:', error.request);
    }
  } else {
    console.error('Error setting up request:', error.message);
  }
  throw error;
};

// ----------------------------
// Authentication Functions
// ----------------------------
export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/widget/login`, {
      username,
      password
    });
    const data = handleResponse(response);

    if (data.token) {
      localStorage.setItem("jwtToken", data.token);
    }

    return data;
  } catch (error) {
    handleError(error);
  }
};

export const refreshToken = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/widget/refresh`);
    const data = handleResponse(response);
    if (data.token) {
      localStorage.setItem('jwtToken', data.token);
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('tokenRefreshed'));
      }
    }
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const logoutUser = async () => {
  try {
    localStorage.removeItem("jwtToken");
    const response = await axios.post(`${API_BASE_URL}/api/widget/logout`);
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};
